import { render, staticRenderFns } from "./SpecialisationList.vue?vue&type=template&id=050d975b&lang=pug&"
import script from "./SpecialisationList.vue?vue&type=script&lang=js&"
export * from "./SpecialisationList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports